import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
@Component({
    selector: 'toggle-using-alternative-agreement-modal',
    styleUrls: ['./toggle-using-alternative-agreement-modal.component.scss'],
    template: `
        <div class="toggle-using-alternative-agreement-modal">
            <div class="bottom-margin" *ngIf="usingAlternateAgreement">
                <p class="body">
                    {{ modalAgreementAlternativeCopyTurnOnI18n
                    }}<b> {{ modalAgreementAlternativeNoteTurnOnI18n }}</b>
                </p>
                <br />
                <b>{{ modalAgreementAlternativeEligibilityNoteTurnOnI18n }}</b>
            </div>
            <div class="bottom-margin" *ngIf="!usingAlternateAgreement">
                <p class="body">{{ modalAgreementAlternativeCopyTurnOffI18n }}</p>
                <br />
                <b>{{ this.modalAgreementAlternativeEligibilityNoteTurnOffI18n }}</b>
            </div>
            <data-card class="bottom-margin">
                <div class="data-item">
                    <div class="data-header p label">Buyer:</div>
                    <div class="data-value p body">{{ buyerName }}</div>
                </div>
                <div class="data-item">
                    <div class="data-header p label">Supplier:</div>
                    <div class="data-value p body">{{ supplierPreferredName }}</div>
                </div>
            </data-card>
        </div>
    `
})
export class ToggleAlternativeAgreementModalComponent {
    public readonly modalAgreementAlternativeCopyTurnOnI18n = this._i18n({
        value:
            'Enabling Alternative Supplier Agreement will remove the click through agreement the supplier would typically see and agree to in their enrollment flow.',
        description: 'Warning when enabling alternative agreement'
    });

    public readonly modalAgreementAlternativeNoteTurnOnI18n = this._i18n({
        value:
            'Another electronic or physical supplier agreement will still need to be signed to enable early payments.'
    });

    public readonly modalAgreementAlternativeEligibilityNoteTurnOnI18n = this._i18n({
        value: 'Eligibility will be disabled.'
    });

    public readonly modalAgreementAlternativeCopyTurnOffI18n = this._i18n({
        value:
            'Disabling the Alternative Supplier Agreement will reinstate the Click Through Agreement to the enrollment flow.',
        description: 'Warning when disabling alternative agreement'
    });

    public readonly modalAgreementAlternativeEligibilityNoteTurnOffI18n = this._i18n({
        value: 'Eligibility will not be changed.'
    });

    public usingAlternateAgreement: boolean;
    public supplierPreferredName: string;
    public buyerName: string;

    constructor(private _modalService: ModalService, private _i18n: I18n) {
        const modalData = this._modalService.modal.data;

        this.usingAlternateAgreement = modalData.usingAlternateAgreement;
        this.supplierPreferredName = modalData.supplierRelationship.supplierPreferredName;
        this.buyerName = modalData.supplierRelationship.allSellerRelationships.find(
            (relationship) => relationship.buyerKey === modalData.supplierRelationship.buyerKey
        ).buyerPreferredName;
    }
}
